// Atölye sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'production.workshop';

export const productionWorkshopGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Atölye ekranı nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Atölyede, operasyonlu üretim fişlerinin istasyonlarda bekleyen adımlarını kart olarak görür ve yapılan işi onaylarsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık, operatör, yenile'),
    filters: t(`${G}.regions.filters`, 'İstasyon, şube, arama'),
    table: t(`${G}.regions.table`, 'Adım kartları'),
    pagination: t(`${G}.regions.pagination`, 'Daha fazla'),
  },
  steps: [
    {
      region: 'filters',
      title: t(`${G}.s1.title`, '1. İstasyonunuzu seçin'),
      text: t(`${G}.s1.text`, '"İstasyon" listesinden çalıştığınız istasyonu seçin; "Tümü" bütün istasyonları gösterir. Seçiminiz bu cihazda hatırlanır. Birden çok şube varsa "Şube" ile daraltabilir, "Fiş no veya ürün" kutusuyla arayabilirsiniz.'),
      tips: [
        t(`${G}.s1.tip1`, 'Yalnız Serbest veya Üretimde durumundaki operasyonlu fişlerin bitmemiş adımları listelenir. Taslak fişin adımları görünmez; fişi önce "Serbest bırak" ile serbest bırakın.'),
        t(`${G}.s1.tip2`, '"Yalnız hazır olanlar" açıkken yalnız işlenecek miktarı olan adımlar görünür: ilk adım ya da önceki adımdan gelen sağlam miktarın henüz işlenmediği adımlar.'),
      ],
    },
    {
      region: 'header',
      title: t(`${G}.s2.title`, '2. Operatörü seçin'),
      text: t(`${G}.s2.text`, 'Başlıktaki "Operatör" alanından kendinizi seçin. Seçtiğiniz kişi adım onayı penceresine kendiliğinden gelir ve bu sekme kapanana kadar hatırlanır. Personel listesi alınamazsa adınızı yazabilirsiniz.'),
      tips: [
        t(`${G}.s2.tip1`, 'Liste 30 saniyede bir kendiliğinden yenilenir; "Son yenileme" saati başlıkta yazar. Hemen yenilemek için yenile düğmesine basın.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Kartı okuyun'),
      text: t(`${G}.s3.text`, 'Her kartta fiş no, ürün, "Adım n: ad (toplam adım)", istasyon, büyük rakamla "Bekleyen" miktar, şimdiye kadarki Sağlam ve Fire ile ilerleme çubuğu bulunur. Yeşil çerçeve, adımın işlenmeye hazır olduğunu gösterir.'),
      tips: [
        t(`${G}.s3.tip1`, 'Bekleyen: ilk adımda fişin planlanan miktarı; sonraki adımlarda önceki adımın sağlamından bu adımda işlenmiş (sağlam + fire) miktar düşülerek bulunur.'),
        t(`${G}.s3.tip2`, 'Karttaki (i) simgesi adımın talimatını gösterir. Turuncu "n kontrol" etiketi adımda girilmesi gereken kalite kontrolü olduğunu belirtir.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Yaptığınız işi onaylayın'),
      text: t(`${G}.s4.text`, 'Karta dokunun; "Adım onayı" penceresi açılır. Sağlam ve fire miktarını girip "Kaydet"e basın. Kaydettiğiniz anda bu adıma ait malzemeler stoktan düşer; ayrıntılar pencerenin kendi (i) rehberindedir.'),
      tips: [
        t(`${G}.s4.tip1`, 'Bir adıma, önceki adımın sağlam miktarından fazlası girilemez.'),
        t(`${G}.s4.tip2`, 'Son adım da bitince fişi tamamlamak isteyip istemediğiniz sorulur. Mamul stoğa ancak fiş tamamlanınca girer.'),
      ],
    },
    {
      region: 'pagination',
      title: t(`${G}.s5.title`, '5. Daha fazla kart'),
      text: t(`${G}.s5.text`, 'Kartlar üretim tarihine ve fiş numarasına göre sıralanır; ekranda 30 adım görünür. Fazlası için alttaki "Daha fazla" düğmesine basın. Başlıktaki (i) bu rehberi yeniden açar.'),
    },
  ],
});
